import { render, staticRenderFns } from "./ItemPriceTrial.vue?vue&type=template&id=e5ac4830&scoped=true&"
import script from "./ItemPriceTrial.vue?vue&type=script&lang=js&"
export * from "./ItemPriceTrial.vue?vue&type=script&lang=js&"
import style0 from "./ItemPriceTrial.vue?vue&type=style&index=0&id=e5ac4830&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ac4830",
  null
  
)

export default component.exports